<template>
  <MainLayout>
    <div id="noticeable-newspage-embed"></div>
  </MainLayout>
</template>

<script setup lang="ts">
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import { renderNewsPageEmbed } from '@/lib/noticable';
import { onMounted } from 'vue';

onMounted(async () => {
  await renderNewsPageEmbed('#noticeable-newspage-embed');
});
</script>
